import React from "react";
import { SectionLabel } from "./MaskedText";

export function StackSection({ groups }) {
  return (
    <section className="section stack" id="stack">
      <div className="page-width">
        <SectionLabel number="02 /">My stack</SectionLabel>
        <div className="stack__rows">
          {groups.map((group) => (
            <article className="stack-row" key={group.title} tabIndex="0">
              <span className="stack-row__line" data-stack-line />
              <div className="stack-row__heading">
                <h2>{group.title}</h2>
              </div>
              <ul>
                {group.skills.map((skill) => (
                  <li key={skill.name} data-stack-skill>
                    <img className="stack-skill__icon" src={skill.icon} alt="" aria-hidden="true" loading="lazy" />
                    <span>{skill.name}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
